/*
 * We want to be able to render only bars/parts of line that are visible to users,
 * but without introducing visual artifacts like bars missing in front of users while scrolling
 * or lines that start in middle of chart for sparse intraday stock data.
 *
 * In general we want to start rendering lines one bar sooner than what is visible to user and stop rendering
 * one bar outside of visible area to create a continuous line.
 */
export const drawInVisibleArea = (
  data: any[],
  from: number,
  fx: (x: number) => number,
  leftOffset: number,
  width: number,
  drawBarCallback: (i: number, x: number) => void
) => {
  const firstBarToRender = getFirstBarToRenderIndex(data, from, fx, leftOffset)
  if (firstBarToRender === undefined) return

  let drawCalled = false
  let lastBarToRender = -1
  for (let i = firstBarToRender; i < data.length; i++) {
    const x = fx(i)
    if (x + leftOffset > width) {
      lastBarToRender = i
      break
    }
    drawBarCallback(i, x)
    drawCalled = true
  }

  if (drawCalled && lastBarToRender > -1) {
    const x = fx(lastBarToRender)
    drawBarCallback(lastBarToRender, x)
  }
}

export const getFirstBarToRenderIndex = (data: any[], from: number, fx: (x: number) => number, leftOffset: number) => {
  let firstBarToRenderIndex
  for (let i = from; i < data.length; i++) {
    if (fx(i) + leftOffset < 0) {
      continue
    }
    firstBarToRenderIndex = i
    if (i - 1 >= from) {
      firstBarToRenderIndex--
    }
    break
  }
  return firstBarToRenderIndex
}

export const getLastBarToRenderIndex = (data: any[], fx: (x: number) => number, leftOffset: number, width: number) => {
  let lastBarToRenderIndex
  for (let i = data.length - 1; i > 0; i--) {
    lastBarToRenderIndex = i
    if (fx(i) + leftOffset < width) {
      break
    }
  }
  return lastBarToRenderIndex
}
